import React, { Component } from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'
class GenericIntegrationOption extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        if (!this.props.accApp) {
            return (
                <div id={this.props.id} className='automationOption'>
                    Integration no longer connected
                    {!this.props.isRunning && (
                        <div
                            className='automationRemoveStep'
                            onClick={(event) => {
                                event.stopPropagation()
                                this.props.removeStep()
                            }}
                        >
                            <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                        </div>
                    )}
                </div>
            )
        }

        var classes = ' green'
        var outerStyle = {}
        var step = this.props.step
        var accApp = this.props.accApp
        var hook = accApp.Application.options.hooks.find((h) => h.action === step.action)

        if (!this.props.isThemeDesigner) {
            hook.build
                .filter((b) => b.required)
                .forEach((item) => {
                    if (!step.stepOptions[item.value] || !step.stepOptions[item.value].value) {
                        classes = ' incomplete'
                    }
                })
        }

        function hexToRgba(hex, alpha) {
            // Remove # if present
            hex = hex.replace(/^#/, '')

            // Parse r, g, b values
            let r = parseInt(hex.substring(0, 2), 16)
            let g = parseInt(hex.substring(2, 4), 16)
            let b = parseInt(hex.substring(4, 6), 16)

            return `rgba(${r}, ${g}, ${b}, ${alpha})`
        }

        let appBgColor = '#171819'
        if (accApp.Application?.options?.automationBgColor) {
            appBgColor = accApp.Application.options.automationBgColor
        }
        let appLogoUri = accApp.Application.appLogoUri
        if (accApp.Application?.options?.automationLogoUri) {
            appLogoUri = accApp.Application.options.automationLogoUri
        }

        let automationStepBlockStyle = {
            border: '1px solid ' + appBgColor,
            boxShadow: '0px 0px 0px 3px ' + hexToRgba(appBgColor, 0.2)
        }

        let classList = this.props.className || ''
        return (
            <div id={this.props.id} className={classList + ' automationStep'} style={this.props.style || outerStyle}>
                <div
                    className={'automationStepLabel automationStepLabelIntegration'}
                    style={{ backgroundColor: appBgColor }}
                >
                    <img src={appLogoUri} width='14' height='14' alt='' />
                    {accApp.Application.appName}
                </div>
                <div
                    id={this.props.id}
                    className={'automationStepBlock ' + classes}
                    onClick={() => {
                        this.props.editStep(this.props.step)
                    }}
                    style={automationStepBlockStyle}
                >
                    {this.props.statsQueuedHolder}
                    <div>{hook.name}</div>
                    {!this.props.hideDeleteButton && (
                        <div
                            className='automationStepRemove'
                            onClick={(event) => {
                                event.stopPropagation()
                                this.props.removeStep(this.props.stepsData, this.props.dataId, step.guid)
                            }}
                        >
                            <Icons icon='bin' color='#DD4124' style={{ width: 16, height: 16 }} />
                        </div>
                    )}
                    {this.props.statsProcessedHolder}
                    {this.props.contactOnStep}

                    <div className='automationStepCircle'></div>
                </div>
            </div>
        )
    }
}

export default GenericIntegrationOption
